export default __webpack_public_path__ + "static/media/harvest.ffd77486.png";